import { useEffect, useState } from 'react'

import { currentBundle, currentUserEmail, notifyProjectsScreenError } from 'helpers/bugsnag'

type SmokeStatus = 'sending' | 'delivered' | 'failed'

// Smoke-check route for the projects-screen monitoring: opening it fires a
// test error and confirms on screen whether the monitor delivered it.
// Lives under /projects/ so it goes through the exact same path filter that
// gates every real error report.
export const MonitoringSmokeCheck = () => {
  const [status, setStatus] = useState<SmokeStatus>('sending')
  const firedAt = new Date().toISOString()

  useEffect(() => {
    notifyProjectsScreenError(
      new Error(`[smoke-check] projects screen monitoring is active (${firedAt})`),
      { kind: 'smoke-check', firedAt },
      delivered => setStatus(delivered ? 'delivered' : 'failed'),
    )
    // Fire exactly once per visit; firedAt is captured on mount by design
    // eslint-disable-next-line
  }, [])

  const label = {
    sending: 'Sending test error…',
    delivered: 'Monitoring is ACTIVE — test error delivered. Check the dashboard for the [smoke-check] event.',
    failed: 'Monitoring FAILED to deliver the test error. Check network/adblock and the API key.',
  }[status]

  return (
    <div style={{ fontFamily: 'monospace', padding: '2rem', lineHeight: 1.8 }}>
      <h2>Projects screen monitoring — smoke check</h2>
      <p data-status={status}>{label}</p>
      <ul>
        <li>bundle: {currentBundle()}</li>
        <li>user: {currentUserEmail() ?? '(no user in storage)'}</li>
        <li>browser: {window.navigator.userAgent}</li>
        <li>fired at: {firedAt}</li>
      </ul>
    </div>
  )
}
